module.exports = __webpack_public_path__ + "static/media/Ex2-S3.9bdb47cf.PNG";